import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import KnowledgeBaseContent from "../components/knowledge-base/knowledge-base-content";
import XanoAPI from "../lib/XanoAPI";
import Loader from "../components/loader/loader"; // Assuming a loader component exists

const KnowledgeBase: React.FC = () => {
  const api = XanoAPI.getInstance();
  const [articles, setArticles] = useState<KnowledgeBaseArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchArticles = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const fetchedArticles = await api.getAllKnowledgeBaseArticles();
      // Ensure that setArticles only receives a non-null array
      setArticles(fetchedArticles || []); // Fallback to an empty array if fetchedArticles is null
    } catch (err) {
      setError("Failed to load articles. Please try again.");
      console.error("Error fetching articles:", err);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    fetchArticles();
  }, [fetchArticles]);

  return (
    <div className="hidden flex-col md:flex">
      <Header />
      <main className="flex-1 space-y-4 p-8 pt-6 container mt-10 mb-20">
        <div className="pt-10">
          <h2 className="text-3xl font-bold tracking-tight">Knowledge Base</h2>
          <p className="text-muted-foreground">
            Explore our collection of articles and guides.
          </p>
        </div>

        {loading ? (
          <Loader /> // Show loader during data fetch
        ) : error ? (
          <div className="text-red-500 font-semibold">{error}</div>
        ) : (
          <KnowledgeBaseContent articles={articles} />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default KnowledgeBase;
